import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/Home";
import AnalysisList from "@/pages/Analysis";
import StockDetail from "@/pages/StockDetail";
import IPO from "@/pages/IPO";
import Recommendations from "@/pages/Recommendations";
import Calculators from "@/pages/Calculators";
import { EducationList, EducationDetail } from "@/pages/Education";
import AIChat from "@/pages/AIChat";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <LangProvider>
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/analysis" element={<AnalysisList />} />
              <Route path="/analysis/:symbol" element={<StockDetail />} />
              <Route path="/ipo" element={<IPO />} />
              <Route path="/recommendations" element={<Recommendations />} />
              <Route path="/calculators" element={<Calculators />} />
              <Route path="/education" element={<EducationList />} />
              <Route path="/education/:slug" element={<EducationDetail />} />
              <Route path="/ai-chat" element={<AIChat />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
